module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAQCAYAAADqDXTRAAABAklEQVQ4jb3TLUtDYRQH8J9jX8Fi8qMYBF/QIJoUsdlsq7PMbLMOy5o2k0mLgiwZ9BtYRGEwBgqXa/CEcd3uy9z2T89zznnOr9y7sHyZHmLJ/PJWRxf3WJwD+I6VGl6xio8Zg5/hvNSi8Ix19GYE9rAWjtpQo4sN9KcM9rEZ+2VReMQWBlMCB9jGw3Axi/L7Ue3g65/gd+y5yzZGoXCLvXg4Kbgbe/5kHAo32EdSEUxwEO9HJg+FaxxVgJOYv8obKkKhg2OkBXNpzHWKFpZBoY2THDiNfrvMsrIoXKAxpteIfqlUQeEczUytGfXSqYrCGVpxbsW9UuoToHCKJzm/RV5+AGLlNv5C8aoKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/monitor/5.png
// module id = 1635
// module chunks = 2